<template>
  <el-container id="alogUser">
    <el-main style="background:#FFFFFF;padding:15px">
      <div style="display:flex;height:40px;width:100%;line-height:0.3;text-align:left;align-items: center;">
        <div style="margin-right:0.5vw;width:15vw">
          <el-date-picker
            v-model="xz_date"
            @change="upDate"
            size="small"
            style="width:100%"
            type="daterange"
            format="yyyy-MM-dd"
            :clearable="false"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </div>
        <span style="margin-left:0.5vw; color: #ffffff; font-size: 13px">
            <el-input
              placeholder="输入IP查询"
              style="width:10vw;"
              prefix-icon="el-icon-search"
              @keyup.enter.native="init_View()"
              @clear="init_View()"
              clearable
              v-model="scan_ip">
            </el-input>
        </span>
        <span style="margin-left:0.5vw; color: #ffffff; font-size: 13px">
            <el-input
              placeholder="输入操作人员查询"
              style="width:10vw;"
              prefix-icon="el-icon-search"
              @keyup.enter.native="init_View()"
              @clear="init_View()"
              clearable
              v-model="scan_user">
            </el-input>
        </span>
        <el-button @click="dc_data" size="small" type="primary" icon="el-icon-folder"
                   style="margin-left:auto;margin-right:15px">
          导出数据
        </el-button>
      </div>
      <el-table :data=fil_tabData class="tab_adb" :cell-style="tableYs"
                style="width:100%; font-size:13px; background:#FFFFFF;margin-top:10px"
                :max-height=maxHeight show-overflow-tooltip
                :header-cell-style="{'height':'30px','text-align':'center','background':'#F4F4F4','color':'#0dA7C8'}">
        <el-table-column :key=item :prop=d.val :label=d.key :width="d.w"
                         v-for="(d,item) in this.defHead">
        </el-table-column>
      </el-table>
      <el-pagination
        style="float:right; margin-right:0.5vw;margin-top:10px"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange1"
        :current-page="page"
        :page-sizes="[20, 40, 80, 160, 320]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </el-main>
  </el-container>
</template>

<script>

import moment from "moment";
import * as XLSX from "xlsx";

export default {
  name: "alogUser",
  data() {
    return {
      dc_name: "用户日志",
      scan_ip: "",
      scan_user: "",
      page: 1,
      pageSize: 20,
      maxHeight: window.innerHeight - 300,
      defHead: [
        {'key': "", 'val': "", "w": "200px"},
        {'key': "执行时间", 'val': "times", "w": "auto"},
        {'key': "定时名称", 'val': "name", "w": "auto"},
        {'key': "执行结果", 'val': "dev_status1", "w": "auto"},
        {'key': "", 'val': "", "w": "200px"},
      ],
      tabData: [
        // {'times': "1", 'ip': "1", "userName": "5", "dev_mac": 1, "dev_status": 1, "dev_status1": 1},
        // {'times': "2", 'ip': "2", "userName": "6", "dev_mac": 1, "dev_status": 2, "dev_status1": 1},
      ],
      xz_date: this.getYesterday(),
    }
  },
  methods: { /*方法存放*/
    upDate() { /*更新时间*/
      console.log(this.formatDateTime(this.xz_date[0], 'day'));
      console.log(this.formatDateTime(this.xz_date[1], 'day'));
      this.loading = this.$load.service({spinner: "", text: "正在加载中...", background: "rgba(0, 0, 0, 0.3)"});
      this.getData()
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.init_View();
    },
    handleCurrentChange1(val) {
      this.currentPage = val;
      this.init_View();
    },
    dc_data() {
      let data = [];
      var d = []
      for (var i = 0; i < this.defHead.length; i++) {
        d.push(this.defHead[i]['key'])
      }
      data.push(d)
      for (var i = 0; i < this.fil_tabData.length; i++) {
        d = []
        for (var j = 0; j < this.defHead.length; j++) {
          d.push("" + this.fil_tabData[i][this.defHead[j]['val']])
        }
        data.push(d)
      }
      const worksheet = XLSX.utils.aoa_to_sheet(data);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
      const fileName = this.dc_name + `_${this.getDowName()}.xlsx`; // 导出的文件名
      XLSX.writeFile(workbook, fileName);
    },
    getDowName() {
      var startTime = new Date(this.xz_date[0]);
      var endTime = new Date(this.xz_date[1]);
      const month = startTime.getMonth() + 1;
      const day = startTime.getDate();
      const month1 = endTime.getMonth() + 1;
      const day1 = endTime.getDate();
      return `${this.pad(month)}月${this.pad(day)}日-${this.pad(month1)}月${this.pad(day1)}日`
    },
    getYesterday() { /*获取昨天时间*/
      return [new Date(moment().subtract(1, 'day').format('YYYY-MM-DD')), new Date(moment().subtract(0, 'day').format('YYYY-MM-DD'))];
    },
    formatDateTime(date, name) { /*时间解析*/
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const day = date.getDate();
      const hour = date.getHours();
      const minute = date.getMinutes();
      const second = date.getSeconds();
      let data = ""
      switch (name) {
        case "allDate":
          data = `${this.pad(month)}/${this.pad(day)}`
          break
        case "day":
          data = `${year}-${this.pad(month)}-${this.pad(day)}`
          break
      }
      return data
    },
    pad(num) {
      return num.toString().padStart(2, '0');
    },
    tableYs({row, column, rowIndex, columnIndex}) { /*表格文字颜色更换*/
      return 'text-align:center;background:#FFFFFF;color:#828282'
    },
    init_View() {

    },
    getToTime(seconds) {
      var date = new Date(seconds * 1000);
      var year = date.getFullYear();
      var month = ("0" + (date.getMonth() + 1)).slice(-2);
      var day = ("0" + date.getDate()).slice(-2);
      var hour = ("0" + date.getHours()).slice(-2);
      var minute = ("0" + date.getMinutes()).slice(-2);
      var second = ("0" + date.getSeconds()).slice(-2);
      return year + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + second;
    },
    getData() {
      const params = {
        'page': this.page,
        'pageSize': this.pageSize,
        'fromTime': Math.floor(this.xz_date[0].getTime() / 1000),
        'toTime': Math.floor(this.xz_date[1].getTime() / 1000),
      }
      const headers = {
        'token': localStorage.getItem("token")
      }
      this.$api.post(this.$urls.ip + this.$urls.getTimerMgrLogList, params, headers)
        .then(res => {
          let data = res.data.data.list
          console.log("获取定时日志", data)
          this.loading.close()
          let l = []
          for (let i = 0; i < data.length; i++) {
            let d = {
              // times: this.getToTime(data[i]['time']),
              ip: data[i]['ip'],
              userName: data[i]['userName'],
              source: data[i]['source'],
              // dev_status: data[i]['dev_status'],
            }
            let content = JSON.parse(data[i]['content'])
            d["name"] = content['name']
            d["times"] = content['hour'] + ":" + content['minute'] + ":" + content['second']
            d["did"] = content['did']
            l.push(d)
          }
          this.tabData = l
        })
        .catch(error => {
          console.log(error)
          if (error) {
            this.$message.error("获取数据失败")
          }
        })
    },
  },
  mounted() { /*页面加载时调用*/
    this.$urls.ip = localStorage.getItem("srv_ip");
    this.loading = this.$load.service({spinner: "", text: "正在加载中...", background: "rgba(0, 0, 0, 0.3)"});
    this.getData()
  },
  computed: { /*定义计算属性-响应数据改变后重新计算*/
    fil_tabData() {
      return this.tabData.filter(item => {
        return item.ip.toLowerCase().includes(this.scan_ip.toLowerCase()) && item.userName.toLowerCase().includes(this.scan_user.toLowerCase());
      });
    },
    total() {
      return this.tabData.length
    }
  },
  watch: {  /*监听参数变化*/

  },
  beforeDestroy() { /*页面结束时调用*/

  }
}
</script>

<style>
#alogUser {
  margin: 0;
  padding-top: 0;
  background: #FFFFFF;
}

.tab_adb {
  user-select: text;

  .gutter { /*去除表格右边留白*/
    background-color: #FFFFFF !important;
    border: 5px solid #FFFFFF !important;
  }

  .el-table__header-wrapper {
    .el-table__header {
    }
  }

  .el-table__body-wrapper {
    overflow-y: auto;
    background: #FFFFFF;
    height: calc(100% - 66px) !important; /*去除表格底部留白*/
  }

  ::-webkit-scrollbar {
    width: 8px;
    height: 10px;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: #0dA7C8;
  }

  ::-webkit-scrollbar-track {
    border-radius: 8px;
    background-color: #cacaca;
    border: 1px solid #cacaca;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/logs/logTiming.vue